export default __webpack_public_path__ + "static/media/seven.1fb7d5b6.png";